import { onboardingApi } from "@features/onboarding/utility-setup/api";
import { ApiEndpoints } from "@shared/api/api-endpoints";
import { communicationApiClient, cxApiClient, onboardingApiClient } from "@shared/api/clients/apiClientFactory";
import { DEFAULT_PAGE_NUMBER } from "@shared/utils/constants";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";


export const quickMessageApi = {

  sendDirectMessage: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("communication", "direct-message");
    const response = await communicationApiClient.post(url, payload);
    return response.data;
  },
  sendBulkNotification: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("communication", "bulk-notification");
    const response = await communicationApiClient.post(url, payload);
    return response.data;
  },

    getRecipientList: async (recipientType:any): Promise<any> => {
      const url = ApiEndpoints.createUrlWithQueryParameters(
        "communication",
        "recipient-lists",
        (qs) => {
          qs.push("remote_utility_id", getRemoteUtilityId());
           qs.push("audience_type", recipientType);
           qs.push("page", DEFAULT_PAGE_NUMBER);
           qs.push("limit", "20");
        }
      );
      const response = await communicationApiClient.get(url);
      return response.data;
    },


     searchConsumer: async (params: {
    remoteUtilityId: number;
    searchData: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
      "cx",
      "consumer-search",
      ["info"],
      (query) => {
        query.push("remote_utility_id", params.remoteUtilityId.toString());
        query.push("search_data", params.searchData);
        return query;
      }
    );

    const response = await cxApiClient.get(url);
    return response.data;
  },
  getUserInfo: async (params: {
  remoteUtilityId: number;
  page?: number;
  limit?: number;
  searchData?: string;
}): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "auth",
    "user-info",
    (qs) => {
      qs.push("remote_utility_id", params.remoteUtilityId.toString());
      if (params.page) qs.push("page", params.page.toString());
      if (params.limit) qs.push("limit", params.limit.toString());
      if (params.searchData) qs.push("search_data", params.searchData);
    }
  );

  const response = await onboardingApiClient.get(url);
  return response.data;
},

getTemplateList: async (audienceType:any): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "communication",
    "communication-templates",
    (qs) => {
      qs.push("remote_utility_id", getRemoteUtilityId());
       qs.push("audience_type",audienceType);
    }
  );

  const response = await communicationApiClient.get(url);
  return response.data;
},
getTemplateData : async (templateId: any) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "communication",
    `communication-templates/${templateId}`,
    (query) => {
      query.push("remote_utility_id",getRemoteUtilityId());
    }
  );
  const response = await communicationApiClient.get(url);
  return response.data.result ?? [];
},
};
